import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { SupportView } from '../../features/operating-costs/support-view';

export const Route = createFileRoute('/operating-costs/support')({
  staticData: {
    breadcrumb: 'Support',
  },
  component: SupportPage,
});

/**
 * Renders the operating-costs support page when the feature is enabled, or an unavailable message otherwise.
 */
function SupportPage() {
  const enabled = useFeatureFlag('operating_costs');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Operating costs are not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <SupportView partnerId={partnerId} />;
}
